import React from "react"

import {findDOMNode} from "react-dom"
import {PopoverMenuItemType} from "../../../../../gd-components/popover-menu/popover-menu/const"
import PopoverMenuSeparator from "../../../../../gd-components/popover-menu/popover-menu/popover-menu-separator"
import PopoverMenuHeader from "../../../../../gd-components/popover-menu/popover-menu/popover-menu-header"
import PopoverMenuOption from "../../../../../gd-components/popover-menu/popover-menu/menu-option"
import ModelEntity from "../../../../../model2/model-entity"

type Props = {
    parent              : any
    model?              : ModelEntity
    field               : any
    currentOption?      : Option        // in case of stateless parent

    searchString?       : string | null

    keyboardNavigation  : boolean

    onUpdateScroll      : func
    onSetHelpMessage?   : {(hint: string | null): void}
}

const debug = false
// const debug = "DropdownPopoverOptionsSelector"

export default class DropdownPopoverOptionsSelector extends React.Component<Props,any> {

    public optionRef            : any
    public selectedOptionRef    : any

    static defaultProps = {
        keyboardNavigation  : true
    }

    constructor(props:Props) {
        super(props)

        this.state = {
            currentCursorKey: null
        }

        // references for options for keyboard navigation
        this.optionRef = {}
        this.selectedOptionRef = null // required for scroll to selected option
    }

    componentDidMount() {
        debug && console.log(debug, "componentDidMount", this.props.field.scrollToSelected)
        if (this.props.field.scrollToSelected) {
            // setTimeout is required to call it on next frame for VScroll to finish rendering
            setTimeout(()=>{
                const node = this.selectedOptionRef ? findDOMNode(this.selectedOptionRef) : null
                if (node) this.props.onUpdateScroll(node, true)
            }, 0)
        }
    }

    componentDidUpdate(prevProps:any, prevState:any, snapshot:any) {
        const node = this.optionRef[this.state.currentCursorKey] ? findDOMNode(this.optionRef[this.state.currentCursorKey]) : null

        // scroll for cursor to be visible
        if (node) this.props.onUpdateScroll(node)
    }

    _getOptions = () => {

        // Changed by Vic Mar 15 2023 - be able to use smart
        // let options = this.props.field.getOptions().slice()
        let options = this.props.field.getOptionsForEdit(this.props.model).slice()

        options = _.filter(options, option => !option.notSelectable)

        // filter options by search string
        let searchString = this.props.searchString
        if (searchString) {
            searchString = searchString.toLowerCase()
            options = _(options)
                .filter(option => option.label && option.label.toLowerCase().includes(searchString))
                .value()
        }

        // add no value if necessary
        if (this.props.field.noValueOption) {
            options.unshift({
                value   : null,
                icon    : this.props.field.noValueOptionIcon,
                label   : this.props.field.noValueOptionLabel
            })
        }

        return options
    }

    onClickOption = (option: Option) => {
        this.props.parent.onOptionClick(option)
    }

    onChangeCursorOption = (newValue:any) => {
        this.setState({currentCursorKey: newValue})
    }

    onPopoverKeyDown = (event:any) => {
        if (!this.props.keyboardNavigation) return

        const options = this._getOptions()

        let newValue

        switch(event.key) {
            case 'Escape': this.props.parent.hidePopover(); break

            case 'ArrowUp':
                if (this.state.currentCursorKey === null) {
                    newValue = 0
                } else {
                    newValue = this.state.currentCursorKey - 1
                    if (newValue < 0) newValue = 0
                }

                this.onChangeCursorOption(newValue)
                break

            case 'ArrowDown':
                if (this.state.currentCursorKey === null) {
                    newValue = 0
                } else {
                    newValue = this.state.currentCursorKey + 1
                    if (newValue > options.length - 1) newValue = options.length - 1
                }

                this.onChangeCursorOption(newValue)
                break

            case 'Enter':
                if (this.state.currentCursorKey !== null) {
                    const curOption = options[this.state.currentCursorKey]
                    if (curOption) this.onClickOption(curOption)
                }
                break
        }
    }

    _optionReference = (key:any, r:any, isSelected:any) => {
        this.optionRef[key] = r
        if (isSelected) this.selectedOptionRef = r
    }

    render() {
        const {field}           = this.props
        const options           = this._getOptions()
        const highlightedOption = options[this.state.currentCursorKey]
        const currentOption     = this.props.parent.state.currentOption || this.props.currentOption
        const noOptions         = _.isEmpty(options)

        return (
            <>
                {noOptions &&
                    <PopoverMenuOption option={{
                        label       : this.props.field.noOptionsLabel,
                        disabled    : true
                    }}/>}

                {_.map(options, (option, key)=> {
                    if (option.excludeFromSelectable) return false

                    if (option.type === PopoverMenuItemType.SEPARATOR) {
                        return <PopoverMenuSeparator key={key} />
                    }

                    if (option.type === PopoverMenuItemType.HEADER) {
                        return <PopoverMenuHeader title={option.title} key={key} />
                    }

                    const isSelected = currentOption && currentOption.value === option.value
                    return <field.components.PopoverOption ref                  = {(r:any)=>this._optionReference(key, r, isSelected)}
                                                           // key              = {option.value || key}
                                                           key                  = {key} // patch - option value 0 false ... sovpadaet s key... prikol
                                                           field                = {this.props.field}
                                                           option               = {option}
                                                           isHighlighted        = {highlightedOption && highlightedOption.value === option.value}
                                                           isSelected           = {isSelected}
                                                           currentOption        = {currentOption}
                                                           highlightedOption    = {highlightedOption}
                                                           onSetHelpMessage     = {this.props.onSetHelpMessage}
                                                           onClick              = {(additionalOption: Option)=> {
                                                               this.onClickOption(!!additionalOption ? additionalOption : option) // Tut option mojet prixodit is PopoverOption !!!
                                                           }}/>
                    }
                )}
            </>
        )
    }
}
